import type { IconSvgObject } from './types';

const BrochureIcon: IconSvgObject = [
  ["path", { d: "M16.5 3.5H7.5C6.39543 3.5 5.5 4.39543 5.5 5.5V18.5C5.5 19.6046 6.39543 20.5 7.5 20.5H16.5C17.6046 20.5 18.5 19.6046 18.5 18.5V5.5C18.5 4.39543 17.6046 3.5 16.5 3.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 6.5H21C21.5523 6.5 22 6.94772 22 7.5V17.5C22 18.0523 21.5523 18.5 21 18.5H18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.5 6.5H3C2.44772 6.5 2 6.94772 2 7.5V17.5C2 18.0523 2.44772 18.5 3 18.5H5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 8H9M15 12H9M15 16L9 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default BrochureIcon;
